import React from 'react';
import ReactDOM from 'react-dom';
import './episodes.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from "react-router-dom";


/* ---------------------RESOURCES--------------------- */
class Ep extends React.Component{
    constructor(props){
        super(props);
    }

    render(){
        return(
            <div className="longerPage container-fluid">
                <span class="topButtons"><button className="eButton"><Link to="/Episodes">Episodes</Link></button><button className="hButton"><Link to="/">Home</Link></button></span>

                
                {/*Titles*/}
                <div className="row">
                    <div className="title-wrapper col-12">
                        <h1 className="title">Season 2, Episode 2: Flower Knights of Silla</h1>
                        <h5 className="korean-title">시즌 2, 에피소드 2: 신라의 화랑</h5>
                    </div>
                </div>

                {/*VOCABULARY*/}
                <div class="vocabList">

<span class="italics">Listen to the episode <a target="_blank" href="https://anchor.fm/learn-korean-culture/episodes/S2--Episode-2-Flower-Knights-of-Silla-e14lc9d">here</a>!</span> <br></br>
<br></br>

{/* HISTORICAL BACKGROUND */}
신라 (sil la) — Silla <br></br>
화랑 (hwa rang) — flowering knights of Korea during the Silla period <br></br>
삼국시대 (sam guk shi dae) — three kingdoms period, when three kingdoms 고구려, 백제, 신라 ruled the Korean peninsula from 57BCE to 668AD <br></br>
<br></br>Pictured below: the three kingdoms that ruled during the 삼국시대 (three kingdoms period)
<br></br><img className="epPic-m" src="https://upload.wikimedia.org/wikipedia/commons/1/16/History_of_Korea-576.png"></img><br></br><br></br>
멸망하고 나서 (myeol mang ha go nah suh) — after it collapsed <br></br>
만들어졌습니다 (man deul uh jut sep ni dah) — it was created <br></br>
가야 (ga yah) — fourth kingdom during the three kingdoms period <br></br>

{/* CULTURE*/}
<br></br>
만만하다 (man man ha da) — to be weak and easily taken advantage of <br></br>
삼국시대 때 (sam guk shi dae ttae) - during the three kingdoms period <br></br>
한문학 (han mun hak) — Korean literature <br></br>
발전하다 (bal jun ha da) — to develop <br></br>
한자 (han ja) — traditional chinese characters in writing <br></br>
<br></br>Pictured below: 한자, traditional chinese characters and their meanings in Korean
<br></br><img className="epPic-m" src="https://blog.kakaocdn.net/dn/baQXu0/btqDeTcd4xS/MAPFbA53OCHncmt1pIjpgk/img.jpg"></img><br></br><br></br>
본격적으로 (bon gyeok jeok uh ro) - actually <br></br>
쓰기 시작했어요 (sseu gi si jak haet suh yo) - began using <br></br>
아직도 (ah jik doe) - even today <br></br>
많은 (man eun) - many <br></br>
단어들 (dan uh deul) - words <br></br>
뜻 (ddeut) - meaning <br></br>
<br></br>
미술 (mi sul) - art <br></br>
벽화 (byuk hwa) - mural <br></br>
<br></br>Pictured below: 벽화, murals from this time period
<br></br><img className="epPic-m" src="https://img.koreatimes.co.kr/upload/newsV2/images/130726_p12_goguryeo1.jpg/dims/resize/740/optimize"></img><br></br><br></br>
불교 (bul gyo) - buddhism <br></br>
미술품 (mi sul pum) - artworks <br></br>
만들었어요 (man deul uht suh yo) - made <br></br>
불상 (bul sang) — statues of those who obtained Buddhahood <br></br> 
<br></br>Pictured below: 불상, Buddhist statues
<br></br><img className="epPic-sm" src="https://post-phinf.pstatic.net/MjAyMDAxMjhfMTU3/MDAxNTgwMjIwMzY2NDg0.gQYobWaczBDXZkycINhfk33pZZ7ED7_Up0o4i3AdYd4g.Zht2UIrGd385-4lsXufpvnbR9W8P6s538z9nsVzB_Esg.PNG/석굴암_본존불.png?type=w1200"></img><br></br><br></br>
탑 (tap) — towers <br></br>
<br></br>Pictured below: 불교의 탑, Buddhist towers
<br></br><img className="epPic-sm" src="http://newsteacher.chosun.com/site/data/img_dir/2016/09/21/2016092100176_0.jpg"></img><br></br><br></br>

{/* HWARANGS */}
꽃 (kkot) — flower <br></br>
남자 (nam jah) — men <br></br>
청소년 (chung so nyeon) — teenager <br></br>
이루어지다 (eeh ruh uh jih da) — to be formed <br></br>
심신 (sim seen) — the mind and body <br></br>
수련 (sooh ryeon) — training <br></br>
무사 조직 (muh sah jo jik) — warrior group <br></br>
[Note: 심신 is also a word derived from 한자. The first letter 심 in 심신 stands for 신심 (身心) which means mind and the second letter 신 in 심신 stands for 심체 (심체) which means body. And 수련 means training, so 심신 수련 means training of the body and mind.] <br></br>

{/* TRAINING */}
<br></br>
예를 들면 (yeh rul deul myeon) — for example <br></br>
칼쓰기 (kal sseu gi) — how to use a sword <br></br>
창쓰기 (chang sseu gi) — how to use a spear <br></br>
활쏘기 (hwal sso gi) — shooting arrow <br></br>
말타기 (mal ta gi) — how to ride a horse <br></br>
달리기 (dal li gi) — running <br></br>
뜀뛰기 (ddim ddi gi) — jumping <br></br>
헤엄치기 (hae uhm chi gi) — swimming <br></br>
줄다리기 (jul da ri gi) — tug of war <br></br>
<br></br>
그 뿐이 아니라 (geu ppun eeh ah ni ra) — not only that <br></br>
시가 (si gah) — poetry <br></br>
음악 (eum ahk) — music <br></br>
가무 (gah muh) — singing and dancing <br></br>
<br></br>
다른 (dah reun) — other, different <br></br>
교육 (gyo yuk) — education <br></br>
받았어요 (bad at sseu yo) — received <br></br>

{/*EDUCATION */}
<br></br>
교재 (gyo jae) — textbook <br></br>
역사서 (yuk sah suh) — history books  <br></br>
공부했습니다 (gong buh haet sseup ni da) - studied (study=공부하다)  <br></br>
삼국지, 춘추, 한서 — works recounting history of Korea and neighboring countries like Chinese states <br></br>
<br></br>
사자성어 (sah jah sung uh) — a type of idiomatic expression consisting of four traditional Chinese characters (note that the ‘사’ means four) <br></br>
1. 사군이충 (事君以忠) — 왕국과 왕에게 충성을 맹세할 것, show allegiance to one’s sovereign. <br></br>
2. 사친이효 (事親以孝) — 부모에게 효도하는 것, treat one's parents with respect and devotion. <br></br>
3. 교우이신 (交友以信) — 동무들을 신뢰하고 솔직히 대할것, exhibit trust and sincerity amongst friends. <br></br>
4. 임전무퇴 (臨戰無退) — 전쟁에서 후퇴하지 말 것, never retreat in battle. <br></br>
5. 살생유택 (殺生有擇) — 누군가의 목숨을 끊을 때 신중이, 조심스럽게 할 것, exercise discretion when taking a life. <br></br>
<br></br>
해변 (hae byeon) — the beach <br></br>
<br></br>Pictured below: 금강산 강원도 해변, The beach where the 화랑's are said to have trained
<br></br><img className="epPic-m" src="https://i.ytimg.com/vi/u20nvm_0jCk/maxresdefault.jpg"></img><br></br><br></br>
잘생긴 남자 (jal saeng gin nam ja) — handsome man <br></br>
꽃 (kkot) — flower <br></br>
통틀어 (tong teul uh) — in total <br></br>
2백 (eeh baek) — 200 <br></br>
명 (myeong) — used to signify that we are counting people <br></br>
대체로 (dae chase roh) — mostly <br></br>
왕 (wang) — king <br></br>
귀족 (gwi jok) — nobility <br></br>
평민 (pyung min) — commoner <br></br>



                </div>
                <div className="row"><div className="col-12 spacer5"></div></div>
            </div>


        )
    }
}


/* -------------------------Variables------------------------- */
function App() {
    return (
        <div>
        <Ep></Ep>
        </div>
    );
}


  const Episode = () => (
    <div className='app'>
        <App />
    </div>
  );


export default Episode;